module.exports = __webpack_public_path__ + "static/media/accounts.74814236.svg";